import dayjs from '../../../../shared/services/dayjs.js';
import { feiertagFilter } from '../../../../util/util.js';

class DatumService {
    constructor() {
        // Wir wollen immer mit Montag beginnen..., standard startOf Week ist Sonntag.
        this._laufendesDatum = dayjs.tz(new Date(), dayjs.tz.DEFAULT_TZ).startOf('week'); 
        this._kalenderWoche = this.laufendesDatum.add(14, 'hours').isoWeek(); // isoWeek() nimmt local TZ: für Zeitzonen Behandlung addieren wir 14h
    }

    wechsleWoche(wochenAnzahl) {
        this._laufendesDatum = this._laufendesDatum.add(wochenAnzahl, 'weeks'); 
        this._kalenderWoche = this._laufendesDatum.add(14, 'hours').isoWeek(); // isoWeek() nimmt local TZ: für Zeitzonen Behandlung addieren wir 14h
    }

    /**
     * @returns Montag der aktuellen KW
     */
    get laufendesDatum() {
        return this._laufendesDatum;
    }

    get kalenderWoche() {
        return this._kalenderWoche;
    }

    get monate() {
        return dayjs.months();
    }

    /**
     * Gibt ein Array aller Daten der Woche zurück
     * @returns Date Array
     */
    holeWochenDatenFormat() {
        const ersterTag = this._laufendesDatum;
        const wochenDaten = [];

        // Formatiert das Datum in gewohnter weise (tt.mm.yyyy)
        for (let i = 0; i < 7; i += 1) {
            const tmpDate = ersterTag.add(i, 'days');
            wochenDaten.push(tmpDate.format('DD.MM.YYYY'));
        }
        return wochenDaten;
    }

    holeWochenDaten() {
        const ersterTag = this._laufendesDatum;
        const wochenDaten = [];

        // Formatiert das Datum in gewohnter weise (tt.mm.yyyy)
        for (let i = 0; i < 7; i += 1) {
            const tmpDate = ersterTag.add(i, 'days');
            wochenDaten.push(tmpDate);
        }
        return wochenDaten;
    }

    /**
     * @param {Date} laufendesDatum von dem man die KW ausrechnen will
     * @returns Kalenderwoche des laufenden Datums
     */
    berechneKalenderwoche(laufendesDatum) {
        return dayjs(laufendesDatum).add(14, 'hours').isoWeek(); // isoWeek() nimmt local TZ: für Zeitzonen Behandlung addieren wir 14h
    }

    /**
     * Liest die Feiertage vom Basedata provider aus und filter diese nach Bundesland
     * @param {string} bundesland z.B. 'Bayern'
     * @param {string} feiertageBetrieb regionale feiertagseinstellungen
     * @param {boolean} refresh falls die feiertage neu geladen werden sollen.
     * @returns Feiertage eines Bundeslandes
     */
    async fetchFeiertage(bundesland = '', feiertageBetrieb, refresh = false) {
        if (!this.feiertage || refresh) {
            try {
                const response = await fetch('/neolohn/api/feiertage-basedataprovider');
                if (response.ok) {
                    this.feiertage = await response.json();
                }
            } catch (error) {
                console.log(error);
                return [];
            }
        }
        const bundesFeiertage = feiertagFilter(this.feiertage, bundesland, feiertageBetrieb);
        const bundesFeiertagMap = Object.fromEntries(
            bundesFeiertage.map((ft) => [ft.dateFormat, ft])
        );
        return bundesFeiertagMap;
    }
}

const datumService = new DatumService();
export { datumService };
